export const InviteStatus = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  NOT_SET: 'NOT_SET',
};
export type TInviteStatus = (typeof InviteStatus)[keyof typeof InviteStatus];
